import { BannersHome } from '../../../pages/home/organisms/BannersHome';
import { sendEvent } from '../../../services/user-interaction.service';
import Modal from '../../molecules/Modal/Modal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { ANALYTICS_EVENTS } from '../../../shared/constants/events';
import { useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { useStorage } from '../../../shared/utils/general.util';
import STORAGE_KEYS from '../../../shared/constants/storage';

const ModalNotifications = ({
	open,
	onClose,
}: {
	open: boolean;
	onClose: () => void;
}) => {
	const userProfile = useSelector((state: RootState) => state.profile.user);
	const isMobile = useMediaQuery('(max-width: 768px)');

	useEffect(() => {
		if (!userProfile || !open) return;
		sendEvent({
			user_id: userProfile?.id,
			event: ANALYTICS_EVENTS.NOTIFICATIONS_VIEW,
			source: isMobile ? 'app' : 'web',
			event_payload: {},
		});
		useStorage().setItem(STORAGE_KEYS.NOTIFICATIONS_VIEWED, 'true');
	}, [userProfile, open]);

	return (
		<Modal
			open={open}
			onClose={onClose}
			sx='flex flex-col gap-3 w-full max-w-[94dvw] md:max-w-[800px]'
		>
			<p className='font-bold text-xl'>Tus notificaciones</p>
			<hr />
			<div>
				<BannersHome callbackAction={onClose} />
			</div>
		</Modal>
	);
};

export default ModalNotifications;
